import api from "../../../../Shared/interceptor/apiOrp";
import { ENDPOINTS } from "../constant";
import { planDataMapper } from "../mapper";
import { ORP_BASE_URL, POST, SUCCESS_CODE } from "../../../GlobalConstant";

export const getMIFIBundleData = async (payLoad) => {
  try {
    const bundleData = await api.request({
      method: POST,
      url: `${ORP_BASE_URL}${ENDPOINTS.MIFI_PLANS_URL}`,
      data: payLoad
    });
    if (bundleData?.data?.statusCode === SUCCESS_CODE) {
      return bundleData?.data?.result?.map((item) => planDataMapper(item)) ?? []
    }
  } catch (e) {
    throw Error(e)
  }
}

export const submitLead = async (payLoad) => {
  const payloadData = {
    formType: "4G_LEAD_SUBMIT",
    data: payLoad
  }
  try {
    const leadData = await api.request({
      method: POST,
      url: `${ORP_BASE_URL}${ENDPOINTS.SUBMIT_LEAD_URL}`,
      data: payloadData
    });
    if (leadData?.data?.statusCode === SUCCESS_CODE) {
      return leadData?.data?.result
    } else {
      throw new Error(leadData?.data?.message)
    }
  } catch (e) {
    throw new Error(e)
  }
}

